import Guider from './src/guider.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToGuider: SFCWithInstall<typeof Guider> = withInstall(Guider)

export default ToGuider

export * from './src/instance'
